import axios from 'axios';
import { Money } from 'v-money';
import { mapState, mapActions } from 'vuex';

import AppGravarVisitaDialog from './dialogs/GravarVisitaDialog.vue';
import AppRetirarPlacaDialog from './dialogs/RetirarPlacaDialog.vue';
import AppColocarPlacaDialog from './dialogs/ColocarPlacaDialog.vue';
import AppFichaDoImovelDialog from './dialogs/FichaDoImovelDialog.vue';
import AppReservarImovelDialog from './dialogs/ReservarImovelDialog.vue';
import AppDuplicarImovelDialog from './dialogs/DuplicarImovelDialog.vue';

import AppUploadArquivoDialog from '../shared/dialogs/UploadArquivoDialog.vue';
import AppCriarDiretorioDialog from '../shared/dialogs/CriarDiretorioDialog.vue';
import AppGravarObservacaoDialog from '../shared/dialogs/GravarObservacaoDialog.vue';
import AppPerguntasFormularioDialog from "../shared/dialogs/PerguntasFormularioDialog.vue";

import { ESTADOS, TIPOS_IMOVEIS, STATUS_VENDA, OPERACAO_IMOVEL, CATEGORIAS_VENDA, POSSE_CHAVE, AUTORIZACAO_PLACA, AUTORIZACAO_VENDA } from '../util/constantes.js';
import Util from '../util/funcoes.js';
import URLS from '../util/urls.js';

export default {
  components: {
    AppGravarVisitaDialog,
    AppRetirarPlacaDialog,
    AppColocarPlacaDialog,
    AppFichaDoImovelDialog,
    AppReservarImovelDialog,
    AppDuplicarImovelDialog,
    
    AppUploadArquivoDialog,
    AppCriarDiretorioDialog,
    AppGravarObservacaoDialog,
    AppPerguntasFormularioDialog,

    Money
  },
  data() {
    return {
      //PESQUISA
      area: [
        { label: "Até 50m²", data: "50" },
        { label: "Entre 51m² e 100m²", data: "51" },
        { label: "Entre 101m² e 150m²", data: "101" },
        { label: "Entre 151m² e 200m²", data: "151" },
        { label: "Entre 201m² e 250m²", data: "201" },
        { label: "Entre 251m² e 300m²", data: "251" },
        { label: "Acima de 300m²", data: "300" }
      ],
      quartosSuites: [
        {label: "01", data: "1"},
        {label: "02", data: "2"},
        {label: "03", data: "3"},
        {label: "04", data: "4"},
        {label: "05+", data: "5"}
      ],
      
      //CADASTRO
      validacao: {
        dataCaptacao: [
          { required: true, len: 10 },
        ],
        tipoImovel: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        endereco: [
          { required: true }
        ],
        estado: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        cidade: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        bairro: [
          { type: "object", required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        valor: [
          { type: "number", min: 0.01 }
        ],
        comissao: [
          { type: "number", min: 0.01, max: 100 }
        ]
      },

      imovelSelecionado: undefined,

      tabSelecionada: "detalhes",
      loadingClientes: false,
      loadingCondominios: false,
      loadingCidades: false,
      loadingBairros: false,
      loadingCaptadores: false,
      loadingAtendente: false,
      loadingCaracteristicasImovel: false,
      loadingCaracteristicasCondominio: false,

      captadoresDisponiveis: [],
      captadorSelecionado: {},

      atendentesDisponiveis: [],
      atendenteSelecionado: {},

      comissaoCaptadorSelecionado: 0,

      caracteristicasImovelDisponivel: [],
      caracteristicaImovelSelecionada: {},

      caracteristicasCondominioDisponivel: [],
      caracteristicaCondominioSelecionada: {},

      visibilidadeCriarDiretorioDialog: false,
      visibilidadeDuplicarImovelDialog: false,
      visibilidadeDialogFichaDoImovel: false,
      visibilidadeColocarPlacaDialog: false,
      visibilidadeGravarVisitaDialog: false,
      visibilidadeRetirarPlacaDialog: false,
      
      visibilidadePerguntasFormularioDialog: false,
      visibilidadeUploadArquivoDialog: false,
      visibilidadeGravarObservacaoDialog: false,
      visibilidadeReservarImovelDialog: false,

      observacaoSelecionada: {},
      observacaoEmEdicao: undefined,
      formularioSelecionado: { perguntasFormulario: [] },
      visitaSelecionada: undefined,
      placaRemocao: {},

      position: {
        lat: 45.508,
        lng: -73.587
      },

      formulariosProps: {
        label: "nome",
        children: "formularios"
      },

      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },

      percent: {
        decimal: ',',
        thousands: '.',
        suffix: ' %',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "IMOVEIS_VENDA" })[0] }
    }),
    ...mapState('imoveisStore', {
      imoveis(state) { return state.imoveisListados },
      imovelPesquisa(state) { return state.imovelPesquisa },

      imovel(state) { return state.imovelSelecionado },
      logs(state) { return state.logs },

      clientesDisponiveis(state) { return state.clientesDisponiveis },
      condominiosDisponiveis(state) { return state.condominiosDisponiveis },
      cidadesDisponiveis(state) { return state.cidadesDisponiveis },
      bairrosDisponiveis(state) { return state.bairrosDisponiveis },
      formularios(state) { return state.formularios; }
    }),

    util() { return Util },
    estados() { return ESTADOS },
    categorias() { return CATEGORIAS_VENDA; },
    tiposImoveis() { return TIPOS_IMOVEIS; },
    status() { return STATUS_VENDA; },
    operacao() { return OPERACAO_IMOVEL; },
    posseChave() { return POSSE_CHAVE; },
    autorizacaoPlaca() { return AUTORIZACAO_PLACA; },
    autorizacaoVenda() { return AUTORIZACAO_VENDA; },

    imovelNovo() { 
      return this.imovel.id == 0 
    },

    disableAlteracao() { return this.imovel.id != 0 },

    //CAMPOS
    exibirCampoCondominio() {
      return [1, 3, 5, 7, 8, 9].includes(this.imovel.tipoImovel.id);
    },
    exibirCampoProprietario() {
      return this.imovel.categoria == "IMOVEL_AVULSO";
    },
    exibirCamposLancamento() {
      return this.imovel.categoria == "LANCAMENTO";
    },
    exibirCamposAgio() {
      return this.imovel.agio
    },
    exibirCampoAdiconarCaptador() {
      return (this.imovel.id == 0 && this.permissoes.cadastro) 
        || (this.imovel.id != 0 && this.permissoes.alteracaoCorretor)
    },
    
    //PESQUISA
    exibirBotaoNovo() {
      return this.permissoes.cadastro;
    },

    //IMOVEL
    exibirBotaoGravar() { 
      return ((this.permissoes.cadastro && this.imovel.id == 0) || (this.permissoes.alteracao && this.imovel.id != 0))
        && this.tabSelecionada == "detalhes"
        && ["DISPONIVEL", "RESERVADO", "INDISPONIVEL"].includes(this.imovel.status);
    },
    exibirBotaoRemover() {
      return this.permissoes.remocao
        && this.imovel.id != 0
        && this.tabSelecionada == "detalhes"
        && ["INDISPONIVEL", "ARQUIVADO"].includes(this.imovel.status);
    },
    exibirBotaoGerarFicha() {
      return this.tabSelecionada == "detalhes"
        && this.imovel.id != 0;
    },
    exibirBotaoDuplicar() { 
      return this.permissoes.cadastro
        && this.imovel.id != 0
        && this.tabSelecionada == "resumo";
    },
    exibirBotaoDisponibilizar() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && this.tabSelecionada == "detalhes"
        && ["INDISPONIVEL"].includes(this.imovel.status);
    },
    exibirBotaoIndisponibilizar() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && this.tabSelecionada == "detalhes"
        && ["DISPONIVEL", "ARQUIVADO"].includes(this.imovel.status);
    },
    exibirBotaoArquivar() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && this.tabSelecionada == "detalhes" 
        && ["INDISPONIVEL"].includes(this.imovel.status);
    },

    //FORMULARIO
    exibirBotaoCriarDiretorio() {
      return this.permissoes.geracaoFormularios
        && this.tabSelecionada == "formularios";
    },
    exibirBotaoGerarFormulario() {
      return this.permissoes.geracaoFormularios 
        && this.tabSelecionada == "formularios"
        && !this.formularioSelecionado.nomeArquivo;
    },

    //VISITAS
    exibirBotoesVisita() {
      return this.tabSelecionada == "visitas"
        && this.imovel.id != 0
        && ["DISPONIVEL", "RESERVADO"].includes(this.imovel.status);
    },

    //PLACA
    exibirBotaoColocarPlaca() {
      return this.tabSelecionada == "placas"
        && this.imovel.autorizacaoPlaca == "PERMITIDO"
        && ["DISPONIVEL", "RESERVADO"].includes(this.imovel.status);
    },
    exibirBotaoUploadArquivo() {
      return this.tabSelecionada == "arquivos";
    },

    //OBSERVACOES
    exibirBotaoRemoverObservacao() {
      return this.permissoes.removerObservacoes && this.imovel.id != 0 && this.tabSelecionada == "observacoes";
    },
    exibirBotaoGerarRelatorioObservacao() {
      return this.imovel.id != 0 && this.tabSelecionada == "observacoes";
    },

    //RESERVAS
    exibirBotaoDesfazerReserva() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && this.tabSelecionada == "reservas"
        && this.imovel.status == "RESERVADO";
    },
    exibirBotaoNovaReserva() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && this.tabSelecionada == "reservas"
        && this.imovel.status == "DISPONIVEL";
    },

    //MAPA
    exibirBotaoGravarMapa() {
      return this.permissoes.alteracao
        && this.imovel.id != 0
        && this.tabSelecionada == "mapa";
    },

    labelCategoria() { return CATEGORIAS_VENDA.filter((value) => { return value.data == this.imovel.categoria })[0].label; },
    labelChave() { return CATEGORIAS_VENDA.filter((value) => { return value.data == this.imovel.categoria })[0].label; },

    visitasFiltradas() {
      if(this.atendenteSelecionado == undefined || this.atendenteSelecionado.id == undefined || this.atendenteSelecionado.id == 0) {
        return this.imovel.visitas;
      } else {
        return this.imovel.visitas.filter((visita) => { return visita.usuario.id == this.atendenteSelecionado.id });
      }
    }
  },
  watch: {
    imovelNovo(newValue) {
      if(newValue) {
        this.tabSelecionada = "detalhes";
        this.atendenteSelecionado = {};
      }
    },
    'imovel.id': function(newValue, oldValue) {
      if(newValue != oldValue) {
        this.tabSelecionada = "detalhes";
      }
    },
    'imovel.estado.id': function(newValue, oldValue) {
      if(newValue != oldValue && oldValue != 0) {
        this.imovel.cidade = { id: 0 };
        this.imovel.bairro = { id: 0 };
        
        this.limparCidadesDisponiveis();
        this.limparBairrosDisponiveis();
      }
    },
    'imovel.cidade.id': function(newValue, oldValue) {
      if(newValue != oldValue && oldValue != 0) {
        this.imovel.bairro = { id: 0 };

        this.limparBairrosDisponiveis();
      }
    }
  },
  created() {
    this.pesquisar();
    this.recuperarFormularios({ tipo: "IMOVEL_VENDA" });
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('imoveisStore', [
      'novoImovel',
      'limparImovelPesquisa',
      'listarImoveis',
      'recuperarImovel',

      'limparCidadesDisponiveis',
      'limparBairrosDisponiveis',
      
      'gravarImovel',
      'disponibilizarImovel',
      'indisponibilizarImovel',
      'arquivarImovel',
      'removerImovel',

      'recuperarVisita',
      'removerVisitaImovel',

      'recuperarClientes',
      'recuperarCondominios',
      'recuperarCidades',
      'recuperarBairros',
      
      'recuperarFormularios',
      'recuperarPerguntasFormulario',
      'gerarFormularioImovel',
      'removerDiretorioFormularios',

      'recuperarLogsImovel',
      'recuperarObservacaoImovel',
      'removerObservacaoImovel',
      'gerarRelatorioObservacoesImovel',
      'removerArquivoImovel',
      'desfazerReserva'
    ]),
    //PESQUISA
    formatarLinha1Endereco(imovel) {
      return imovel.endereco + ", " + imovel.numeroEndereco;
    },
    formatarLinha2Endereco(imovel) {
      return (imovel.condominio.nome !== undefined ? imovel.condominio.nome + " - " + imovel.bairro.nome + " - " + imovel.cidade.nome : imovel.bairro.nome + " - " + imovel.cidade.nome)
    },
    formatarValor(valor) {
      return "R$ " + Number(valor).toLocaleString('pt-BR');
    },

    coresPesquisa(status) {
      switch(status) {
        case "RESERVADO":
          return "#FFBC56";
        case "DISPONIVEL":
          return "#87CF87";
        case "INDISPONIVEL":
          return "#FF8686";
        case "ARQUIVADO":
          return "#C3C6CC";
        case "VENDIDO":
          return "#5AB8FF";
      }
    },

    novo() {
      this.novoImovel();
      this.$refs['form'].resetFields();
    },
    pesquisar() {
      this.showLoading();
      
      this.listarImoveis(this.imovelPesquisa)
      .then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
      });
    },
    limparPesquisa() {
      this.limparImovelPesquisa();
    },

    recuperar(imovel) {
      this.showLoading();
      this.recuperarImovel(imovel)
      .then(resultado => {
        switch(resultado.status) {
          case "SUCESSO":
          case "FALHA":
          case "ERRO":
            this.hideLoading();
            break;
        }
      }).catch(() => {
        this.hideLoading();
      })
    },

    //CADASTRO
    getLabel(array, element) {
      return Util.getLabel(array, element);
    },
    tabClicked(tab) {
      if(tab.name === "logs") {
        this.recuperarLogs();
      }
    },
    
    // CAPTADORES
    recuperarCaptadoresSelect(queryString) {
      let payload = { nome: queryString };

      this.loadingCaptadores = true;
      axios.post(URLS.USUARIOS_LISTAR, payload)
      .then((response) => {
        this.loadingCaptadores = false;
        switch(response.data.status) {
          case "SUCESSO":
            this.captadoresDisponiveis = response.data.lista;
            break;
        }
      }).catch(() => {
        this.loadingCaptadores = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },
    adicionarCaptador() {
      if(this.captadorSelecionado == undefined || this.captadorSelecionado.id == undefined || this.captadorSelecionado.id == 0) { return; }
      if(this.comissaoCaptadorSelecionado == undefined || this.comissaoCaptadorSelecionado <= 0) { return; }

      if(this.imovel.captadores.filter((elemento) => { return elemento.id == this.captadorSelecionado.id }).length == 0) {
        this.captadorSelecionado.comissao = this.comissaoCaptadorSelecionado;
        this.imovel.captadores.push(this.captadorSelecionado);
      }

      this.captadoresDisponiveis = [];
      this.captadorSelecionado = {};
      this.comissaoCaptadorSelecionado = 0;
    },
    removerCaptador(captador) {
      this.imovel.captadores = this.imovel.captadores.filter((elemento) => { return elemento.id != captador.id });
    },

    //CARACTERISTICAS IMOVEL
    recuperarCaracteristicasImovelSelect(queryString) {
      let payload = { nome: queryString };

      this.loadingCaracteristicasImovel = true;
      axios.post(URLS.CARACTERISTICAS_IMOVEL_LISTAR, payload)
      .then((response) => {
        this.loadingCaracteristicasImovel = false;
        switch(response.data.status) {
          case "SUCESSO":
            this.caracteristicasImovelDisponivel = response.data.lista;
            break;
        }
      }).catch(() => {
        this.loadingCaracteristicasImovel = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },
    adicionarCaracteristicaImovel() {
      if(this.caracteristicaImovelSelecionada == undefined || this.caracteristicaImovelSelecionada.id == undefined || this.caracteristicaImovelSelecionada.id == 0) { return; }
      if(this.imovel.caracteristicasImovel.filter((elemento) => { return elemento.id == this.caracteristicaImovelSelecionada.id }).length == 0) {
        this.imovel.caracteristicasImovel.push(this.caracteristicaImovelSelecionada);
      }

      this.caracteristicasImovelDisponivel = [];
      this.caracteristicaImovelSelecionada = {};
    },
    removerCaracteristicaImovel(caracteristicaImovel) {
      this.imovel.caracteristicasImovel = this.imovel.caracteristicasImovel.filter((elemento) => { return elemento.id != caracteristicaImovel.id });
    },

    //CARACTERISTICAS CONDOMINIO
    recuperarCaracteristicasCondominioSelect(queryString) {
      let payload = { nome: queryString };

      this.loadingCaracteristicasCondominio = true;
      axios.post(URLS.CARACTERISTICAS_CONDOMINIO_LISTAR, payload)
      .then((response) => {
        this.loadingCaracteristicasCondominio = false;

        if(response.data.status == "SUCESSO") {
          this.caracteristicasCondominioDisponivel = response.data.lista;
        }
      }).catch(() => {
        this.loadingCaracteristicasCondominio = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },
    adicionarCaracteristicaCondominio() {
      if(this.caracteristicaCondominioSelecionada == undefined || this.caracteristicaCondominioSelecionada.id == undefined || this.caracteristicaCondominioSelecionada.id == 0) { return; }
      if(this.imovel.caracteristicasCondominio.filter((elemento) => { return elemento.id == this.caracteristicaCondominioSelecionada.id }).length == 0) {
        this.imovel.caracteristicasCondominio.push(this.caracteristicaCondominioSelecionada);
      }

      this.caracteristicasCondominioDisponivel = [];
      this.caracteristicaCondominioSelecionada = {};
    },
    removerCaracteristicaCondominio(caracteristicaCondominio) {
      this.imovel.caracteristicasCondominio = this.imovel.caracteristicasCondominio.filter((elemento) => { return elemento.id != caracteristicaCondominio.id });
    },

    //IMOVEL
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      this.showLoading();
      this.gravarImovel(this.imovel)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    limpar() {
      this.$refs['form'].resetFields();
    },
    removerHandler() {
      this.$confirm('Deseja realmente remover este imóvel?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.remover();
      }).catch(() => {});
    },
    remover() {
      let payload = { id: this.imovel.id };
      this.showLoading();

      this.removerImovel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      })
    },

    disponibilizar() {
      let payload = { id: this.imovel.id };
      this.showLoading();

      this.disponibilizarImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error('Ocorreu um erro');
      });
    },
    indisponibilizar() {
      let payload = { id: this.imovel.id };
      this.showLoading();

      this.indisponibilizarImovel(payload).then(resultado => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error('Ocorreu um erro');
      });
    },
    arquivar() {
      let payload = { id: this.imovel.id };
      
      this.showLoading();
      this.arquivarImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },

    exibirDuplicarImovelDialog() {
      this.visibilidadeDuplicarImovelDialog = true;
    },
    fecharDialogDuplicarImovel() {
      this.visibilidadeDuplicarImovelDialog = false;
    },

    //IMAGENS
    carregarImagem(indice) {
      this.$refs.imagemSelecionada.src = this.imovel.imagens[indice].path;
    },

    //SELECTS
    recuperarClientesSelect(queryString) {
      let payload = { nome: queryString };
      this.loadingClientes = true;
      this.recuperarClientes(payload)
      .then(() => {
        this.loadingClientes = false;
      });
    },
    selecionarCliente(clienteSelecionado) {
      clienteSelecionado.perfis = [{ perfil: 'PROPRIETARIO', participacaoImovel: 100, participacaoRecebimento: 100}];
      this.imovel.proprietariosBeneficiarios = [clienteSelecionado];
    },
    recuperarCondominiosSelect(queryString) {
      let payload = { nome: queryString };
      
      this.loadingCondominios = true;
      this.recuperarCondominios(payload)
      .then(() => {
        this.loadingCondominios = false;
      });
    },
    recuperarCidadesSelect(queryString) {
      if(this.imovel.estado.id == 0) { return; }

      let payload = { nome: queryString, estado: { id: this.imovel.estado.id } };
      this.loadingCidades = true;
      this.recuperarCidades(payload)
      .then(() => {
        this.loadingCidades = false;
      })
    },
    recuperarBairrosSelect(queryString) {
      if(this.imovel.cidade.id == 0) { return; }

      let payload = { nome: queryString, cidade: { id: this.imovel.cidade.id } };
      this.loadingBairros = true;
      this.recuperarBairros(payload)
      .then(() => {
        this.loadingBairros = false;
      });
    },      

    //PLACAS
    exibirDialogColocarPlaca() {
      this.visibilidadeColocarPlacaDialog = true;
    },
    fecharDialogColocarPlaca() {
      this.visibilidadeColocarPlacaDialog = false;
    },
    exibirDialogRetirarPlaca(placa) {
      this.placaRemocao = Object.assign({}, placa);
      this.placaRemocao.status = "RETIRADA";
      this.placaRemocao.dataRemocao = Util.hoje();
      this.placaRemocao.imovel = { id: this.imovel.id };

      this.visibilidadeRetirarPlacaDialog = true;
    },
    fecharDialogRetirarPlaca() {
      this.visibilidadeRetirarPlacaDialog = false;
    },
    exibirDialogFichaDoImovel() {
      this.visibilidadeDialogFichaDoImovel = true
    },
    fecharDialogFichaDoImovel() {
      this.visibilidadeDialogFichaDoImovel = false;
    },

    //FORMULARIOS - DIRETORIOS
    exibirDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = true;
    },
    fecharDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = false;
    },
    exibirBotaoRemoverDiretorioFormulario(data) {
      return data.nomeArquivo === undefined && data.nome !== 'Outros';
    },
    removerDiretorioHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerDiretorio(diretorio);
      });
    },
    removerDiretorio(diretorio) {
      let payload = { id: diretorio.id, tipoFormularios: diretorio.tipoFormularios, idObjeto: this.imovel.id};

      this.showLoading();
      this.removerDiretorioFormularios(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERROR":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Ocorreu um erro");
        });
    },

    //FORMULARIOS - GERAÇÃO
    selecionarFormulario(formularioSelecionado) {
      if(formularioSelecionado.nomeArquivo !== undefined && formularioSelecionado.nomeArquivo !== null) {
        this.formularioSelecionado = formularioSelecionado;
      } else {
        this.formularioSelecionado = { perguntasFormulario: [] };
      }
    },
    gerarFormulario() {
      if(!this.formularioSelecionado || !this.formularioSelecionado.id) { return; }

      let payload = { id: this.formularioSelecionado.id };

      this.showLoading();
      this.recuperarPerguntasFormulario(payload)
      .then(resultado => {
        switch(resultado.status) {
        case "SUCESSO":
          this.finalizarGeracaoFormulario(resultado);
          break;
        }
      })
      .catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
        this.hideLoading();
      });
    },
    finalizarGeracaoFormulario(resultado) {
      this.formularioSelecionado = resultado.item;
      this.formularioSelecionado.imovel = this.imovel;

      if(this.formularioSelecionado.perguntasFormulario) {
        this.exibirDialogPerguntasFormulario();
        this.hideLoading();
      } else {
        this.gerarFormularioImovel(this.formularioSelecionado)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              window.open(resultado.mensagem, "_blank");
              break;
          }
        }).catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }
    },
    exibirDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = true;
    },
    fecharDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = false;
    },

    //ARQUIVOS
    exibirDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = true
    },
    fecharDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = false;
    },
    removerArquivoHandler(arquivo) {
      this.$confirm('Deseja realmente remover este arquivo?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerArquivo(arquivo);
      }).catch(() => {});
    },
    removerArquivo(arquivo) {
      let payload = { id: arquivo.id };
      
      this.showLoading();
      this.removerArquivoImovel(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERROR":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      });
    },
    downloadArquivoHandler(arquivo) {
      window.open(arquivo.path, "_blank");
    },

    //VISITAS
    exibirDialogGravarVisita() {
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = true;
    },
    fecharDialogGravarVisita() { 
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = false;
    },
    alterarVisita(visita, event, column) {
      if(column.columnKey == "acoes") { return }

      let payload = { id: visita.id, imoveis: [{ id: this.imovel.id }] }

      this.showLoading();
      this.recuperarVisita(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.visitaSelecionada = resultado.item;
            this.visibilidadeGravarVisitaDialog = true;
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    removerVisitaHandler(visita) {
      this.$confirm('Deseja realmente remover esta visita?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerVisita(visita);
      }).catch(() => {});
    },
    removerVisita(visita) {
      let payload = { 
        id: visita.id,
        imoveis: [{ id: this.imovel.id }]
      };
      
      this.showLoading();
      this.removerVisitaImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    recuperarAtendentesSelect(queryString) {
      let payload = { nome: queryString };

      this.loadingAtendente = true;
      axios.post(URLS.USUARIOS_LISTAR, payload)
      .then((response) => {
        this.loadingAtendente = false;

        if(response.data.status == "SUCESSO") {
          this.atendentesDisponiveis = response.data.lista;
        }
      }).catch(() => {
        this.loadingAtendente = false;
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },
    gerarRelatorioVisitas() {
      let payload = { 
        nome: "VISITAS_IMOVEIS",
        imovel: { id: this.imovel.id },
        usuario: { id: this.atendenteSelecionado.id }
      };

      this.showLoading();
      axios.post(URLS.RELATORIOS_GERAR, payload)
      .then((response) => {
        this.hideLoading();
        switch(response.status) {
          case "SUCESSO": 
            window.open(response.data.mensagem, '_blank');
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },

    //OBSERVACOES
    exibirDialogGravarObservacao() {
      this.observacaoEmEdicao = undefined;
      this.visibilidadeGravarObservacaoDialog = true;
    },
    fecharDialogGravarObservacao() {
      this.observacaoEmEdicao = undefined;
      this.visibilidadeGravarObservacaoDialog = false;
    },
    exibirObservacao(observacao) {
      this.observacaoSelecionada = observacao;
    },
    alterarObservacao(observacao, event, column) {
      if(column.columnKey == "acoes") { return }

      let payload = { id: observacao.id };

      this.showLoading();
      this.recuperarObservacaoImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.observacaoEmEdicao = resultado.item;
            this.observacaoSelecionada = {};
            this.visibilidadeGravarObservacaoDialog = true;
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    removerObservacaoHandler(observacao) {
      this.$confirm('Deseja realmente remover esta observação?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerObservacao(observacao);
      }).catch(() => {});
    },
    removerObservacao(observacao) {
      let payload = { id: observacao.id }
      
      this.showLoading();
      this.removerObservacaoImovel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.observacaoSelecionada = {}
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },
    gerarRelatorioObservacao() {
      let payload = { 
        nome: "OBSERVACOES_IMOVEL",
        imovel: { id: this.imovel.id }
      };

      this.showLoading();
      this.gerarRelatorioObservacoesImovel(payload)
      .then((response) => {
        this.hideLoading();
        switch(response.status) {
          case "SUCESSO":
            window.open(response.mensagem, '_blank');  
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },

    //RESERVAS
    exibirDialogReservarImovel() {
      this.visibilidadeReservarImovelDialog = true;
    },
    fecharDialogReservarImovel() {
      this.visibilidadeReservarImovelDialog = false;
    },
    desfazerReservaHandler() {
      let payload = { id: this.imovel.id }
      this.showLoading();

      this.desfazerReserva(payload)
      .then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem)
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem)
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem)
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
    },

    //MAPA
    mapRclicked(mouseArgs) {
      this.position.lat = mouseArgs.latLng.lat();
      this.position.lng = mouseArgs.latLng.lng();
    },
    gravarMapaHandler() {

    },

    //LOGS
    recuperarLogs() {
      let payload = { imovel: { id: this.imovel.id } }
      this.recuperarLogsImovel(payload)
      .catch(() => {
        this.$message.error("Não foi possível recuperar os logs deste imóvel");
      });
    },

    //HELPER FUNCTIONS
    enviar() {
      this.pesquisar();
    }
  }
};